<template>
	<div class="tabWrapperSettings">
		<main-table
				padding="0"
				:flag="flag"
				:headers="getHeaders"
				:listItems="scheduleSchedule"
				@updateClickButton="onClickButton($event, flag)"
				@updateCreate="onCreate"
				text-create="Add new schedule"
				page-title="Schedules"
				:is-filter-refresh="false"
				:is-export="false"
				:is-search="false"
				:is-create="isCreate()"
		></main-table>

		<view-schedule
				v-if="isViewSchedule"
				:dialogFlag="dialogFlag"
				:editSchedulev="editSchedulev"
				@updateSave="onSaveViewSchedule"
				@updateClose="onCloseDialog('isViewSchedule')"
				@updateList="onUpdateList('schedule')"
		></view-schedule>

		<dialog-remove
				v-if="isDialogRemove"
				:titleRemove="titleRemove"
				:textRemove="textRemove"
				@updateRemove="onRemove"
				@updateCloseRemove="onCloseRemove"
		></dialog-remove>
	</div>
</template>

<script>
import MainTable from "@/shared/MainTable/MainTable.vue";
import { tabScheduleTable, TEXT, TITLE } from "@/pages/Settings/UserAccountSettings/constants";
import ViewSchedule from "@/components/Settings/UserAccountSettings/ViewSchedule/ViewSchedule.vue";
import DialogRemove from "@/shared/DialogRemove/DialogRemove.vue";

import { mapActions, mapGetters } from "vuex";
import { PAGE, PERMISSIONS } from "@/constants/constants";
import { getPermissionsMod } from "@/helper/getPermissionsMod";

export default {
	name: "tabSchedule",
	components: { DialogRemove, ViewSchedule, MainTable },
	computed: {
		...mapGetters([
			'editSchedulev',
			'settingsSchedule',
			'scheduleSchedule',
			'filtersSchedule',
			'permissionsDefault',
		]),
		getHeaders() {
			return tabScheduleTable;
		},
	},

	data: () => ({
		flag: PAGE.TABSCHEDULE,

		isViewSchedule: false,
		dialogFlag: null,
		nameComponent: null,
		isDialogRemove: false,
		titleRemove: null,
		textRemove: null,
		activeItem: null,
	}),

	methods: {
		...mapActions([
			'getAccountScheduleList',
			'getAccountScheduleEdit',
			'deleteAccountSchedule',
		]),

		isCreate() {
			const list = this.permissionsDefault;
			const path = [ PERMISSIONS.SETTINGS, PERMISSIONS.USER_ACCOUNT_SETTINGS, PERMISSIONS.U_A_S_SCHEDULE, PERMISSIONS.CREATE ];
			return getPermissionsMod({ list, path });
		},

		async onUpdateList(key) {
			if (key === 'schedule') {
				await this.getAccountScheduleList();
			}
		},

		onClickButton({ key, item }, nameComponent) {
			this.dialogFlag = 'edit';

			this.nameComponent = nameComponent;
			this.activeItem = item;

			if (nameComponent === 'tabSchedule' && key === 'edit1') {
				this.accountScheduleEdit();
			}
			if (nameComponent === 'tabSchedule' && key === 'delete1') {
				const title = TITLE.REMOVE_SCHEDULE;
				const text = TEXT.REMOVE_SCHEDULE;
				this.onRemoveDialog({ title, text });
			}
		},
		async onRemove() {
			if (this.nameComponent === 'tabSchedule') {
				const { id } = this.activeItem;
				await this.deleteAccountSchedule(id);
				this.onCloseRemove();
			}
		},
		onRemoveDialog(args) {
			const { title, text } = args;
			this.titleRemove = title;
			this.textRemove = text;
			this.isDialogRemove = true;
		},
		onCloseRemove() {
			this.isDialogRemove = false;
		},
		async accountScheduleEdit() {
			const { id } = this.activeItem;
			await this.getAccountScheduleEdit(id);
			this.isViewSchedule = true;
		},
		onCreate() {
			this.dialogFlag = 'add';
			this.isViewSchedule = true;
		},
		onSaveViewSchedule(args) {
			console.info('%c [ onSaveViewSchedule args  ] ', 'color:#bada55', typeof args, args );
		},
		onCloseDialog(key) {
			this[key] = false;
		},
	},
	async mounted() {
		await this.getAccountScheduleList();
	}
};
</script>

<style scoped lang="scss">
@import "tabWrapperSettings";
</style>
